import {
    FeesType,
} from 'app/enums/common.enums'
import useShareContext from 'app/shared-components/SharedContext/useSharedContext'

type WithPricingNameType = {
    feePricingName: FeesType,
}

const useFeePricingName = () => {
    const context = useShareContext<WithPricingNameType>()
    const {
        feePricingName,
    } = context

    return feePricingName
}

export default useFeePricingName
